import BoardColumnCards from "../ui/BoardColumnCards";
import BoardViewport from "../ui/BoardViewport";
import { useMemo, useState } from "react";
import { Box, Typography, Stack, Button } from "@mui/material";
import {
  ETAPAS_EXPANSION_KANBAN,
  ETAPAS_EXPANSION_ARCHIVO,
  labelEtapaExpansion,
} from "./expansionConstants";
import ExpansionCard from "./ExpansionCard";

const EMPTY_OPPS = [];

export default function ExpansionKanban({ store, onEdit, onSeguimiento, mostrarArchivo, setMostrarArchivo }) {
  const [draggedId, setDraggedId] = useState(null);
  const [dragOver, setDragOver] = useState(null);
  const moneda = store.config.moneda || "";
  const etapas = [...ETAPAS_EXPANSION_KANBAN, ...(mostrarArchivo ? ETAPAS_EXPANSION_ARCHIVO : [])];
  const opps = store.oportunidadesExpansion || EMPTY_OPPS;

  const porEtapa = useMemo(() => {
    const grouped = {};
    opps.forEach(opp => { (grouped[opp.etapa] ||= []).push(opp); });
    return grouped;
  }, [opps]);
  const leadsById = useMemo(() => new Map(store.leads.map(lead => [lead.id, lead])), [store.leads]);
  const searchText = useMemo(() => opp => {
    const lead = leadsById.get(opp.leadId);
    return [opp.nombre, lead?.nombre, lead?.telefono, String(lead?.telefono || "").replace(/\D/g, ""), opp.proximaAccion].filter(Boolean).join(" ");
  }, [leadsById]);

  return (
    <Box>
      {ETAPAS_EXPANSION_ARCHIVO.length > 0 && (
        <Button size="small" sx={{ mb: 1 }} onClick={() => setMostrarArchivo(!mostrarArchivo)}>
          {mostrarArchivo ? "Ocultar perdidas / pospuestas" : "Ver perdidas y pospuestas"}
        </Button>
      )}
      <BoardViewport gap={1.5}>
        {etapas.map((etapa) => (
          <Box
            key={etapa}
            onDragOver={(e) => { e.preventDefault(); setDragOver(etapa); }}
            onDragLeave={() => setDragOver(null)}
            onDrop={(e) => {
              e.preventDefault();
              const id = e.dataTransfer.getData("oppId");
              if (id) store.moverOportunidadEtapa(id, etapa);
              setDragOver(null);
              setDraggedId(null);
            }}
            sx={{
              minWidth: 220,
              display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden",
              flex: "0 0 220px",
              bgcolor: dragOver === etapa ? "action.hover" : "grey.50",
              borderRadius: 2,
              p: 1,
              outline: dragOver === etapa ? "2px dashed" : "none",
              outlineColor: "primary.main",
            }}
          >
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1} sx={{ flexShrink: 0 }}>
              <Typography variant="subtitle2" fontWeight={700}>{labelEtapaExpansion(etapa)}</Typography>
              <Typography variant="caption" fontWeight={700}>{(porEtapa[etapa]?.length || 0)}</Typography>
            </Stack>
            <BoardColumnCards
              items={porEtapa[etapa] || EMPTY_OPPS}
              label={labelEtapaExpansion(etapa)}
              getSearchText={searchText}
              renderCard={opp => (
                <ExpansionCard
                  key={opp.id}
                  opp={opp}
                  store={store}
                  moneda={moneda}
                  isDragging={draggedId === opp.id}
                  onClick={() => onEdit(opp)}
                  onSeguimiento={onSeguimiento ? () => onSeguimiento(opp) : undefined}
                  onDragStart={(e) => {
                    e.dataTransfer.setData("oppId", opp.id);
                    setDraggedId(opp.id);
                  }}
                  onDragEnd={() => setDraggedId(null)}
                />
              )}
            />
          </Box>
        ))}
      </BoardViewport>
    </Box>
  );
}
